import useSessionStorageState from './src/useSessionStorageState.js';
export default useSessionStorageState;
